@use "../../styles/breakpoint.module.scss" as *;

.card {
    backdrop-filter: blur(20px);
    background: var(--overlay-black-20);
    border-radius: 16px;
    padding: 16px;
    color: var(--off-white);
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media ($above-tablet) {
        padding: 40px 40px 32px;
    }
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.heading {
    font: var(--font-h-40);
    letter-spacing: 0.4px;
    margin: 0;
}

.toggle {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 9999px;
    border: 1px solid rgb(240 237 236 / 20%);
    background: var(--overlay-black-20);
    fill: var(--off-white);
    cursor: pointer;

    svg {
        width: 16px;
        height: 16px;
    }

    @media ($above-tablet) {
        display: none;
    }
}

.content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.body {
    font: var(--font-p-16);
    letter-spacing: 0.48px;
    color: var(--off-white);

    @media ($below-mobile) {
        font: var(--font-p-14);
        letter-spacing: 0.42px;
    }
}

.link {
    font: var(--font-p-14);
    letter-spacing: 0.42px;
    color: var(--off-white);
    text-decoration: underline;
    text-underline-offset: 2px;

    @media ($below-mobile) {
        font-size: 12px;
        letter-spacing: 0.36px;
    }
}

.dataSection {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 14px;
}

.dataEyebrow {
    font: var(--font-eyebrow-14);
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin: 0;

    @media ($below-mobile) {
        font-size: 12px;
        letter-spacing: 1.2px;
    }
}

.dataRows {
    display: flex;
    flex-direction: column;
}

.dataRow {
    display: flex;
    gap: 8px;
    align-items: baseline;
    padding-block: 16px;
    border-top: 1px solid rgb(240 237 236 / 20%);

    &:last-child {
        border-bottom: 1px solid rgb(240 237 236 / 20%);
    }
}

.dataLabel {
    font: var(--font-h-24-forma);
    letter-spacing: 0.72px;
    flex-shrink: 0;
    width: 88px;

    @media ($below-mobile) {
        font-size: 20px;
        letter-spacing: 0.6px;
    }
}

.dataDescription {
    font: var(--font-p-16);
    letter-spacing: 0.48px;
    flex: 1;
    min-width: 0;

    @media ($below-mobile) {
        font: var(--font-p-14);
        letter-spacing: 0.42px;
    }
}

@media ($below-tablet) {
    .collapsed .content {
        display: none;
    }
}
